import { useEffect, useRef, useState } from "react";
import axios from "axios";
import config from "config";
import isEqual from "fast-deep-equal";

const API_URL = config.TRAFFIC;

function getCurrentSeason() {
  const month = new Date().getMonth();
  return month >= 4 && month < 10 ? "s" : "w";
}

export function useTimeTable(type, { onStart, onEnd } = {}) {
  const [rows, setRows] = useState([]);
  const prevDataRef = useRef([]);

  useEffect(() => {
    let isMounted = true;

      const fetchData = async () => {
              onStart?.();

      const season = getCurrentSeason();
      const url = `${API_URL}/th_ktel_${type}_${season}`;

      // console.log(
      //   `[${new Date().toLocaleTimeString()}] Fetching ${type.toUpperCase()} schedule`
      // );

      try {
        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            "accept-profile": "infohub",
          },
        });

        const newData = response.data;

        // Only update if data actually changed
        if (!isEqual(newData, prevDataRef.current)) {
          prevDataRef.current = newData;
          if (isMounted) setRows(newData);
        }
      } catch (err) {
        console.error("Error fetching timetable data:", err);
        if (isMounted) setRows([]);
      } finally {
          onEnd?.();
      }
    };

    fetchData(); // immediate fetch
    const interval = setInterval(fetchData, 300000); // 5 min = 300000 ms || 1min = 60000 ms

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [type]);

  return rows;
}
